var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backgroundLoader d-flex flex-column"},[_c('span',{staticClass:"loader"}),_c('div',{staticClass:"mt-5"},[_vm._v("Cargando .. .")])])
}]

export { render, staticRenderFns }